import classNames from "classnames";
import { NavItemConfig } from "../Siderbar.constant";
import styles from '../Sidebar.module.scss';
import NavItem from "./NavItem";
import CustomDropdown from "./CustomDropDown";
import { useTranslation } from "react-i18next";

type Props = { 
	item: NavItemConfig, 
	isActiveKey: string, 
	isOpenKey: string,
	collapsed: boolean,
	closeOpenMenu?: () => void, 
	handleItemClick: (navItem: NavItemConfig) => void;
	loading?: boolean,
	disableOptions: boolean
}

const RenderNavItem = ({ item, isActiveKey, isOpenKey, collapsed, handleItemClick, closeOpenMenu, loading = false, disableOptions }: Props) => {
	const { t } = useTranslation();
	const hasChildren = 'children' in item && Number(item.children?.length) > 0;
	const isOpen = isOpenKey === item.key;
	const isActive = isActiveKey === item.path;

	return (
		<div key={item.key}>
			{(collapsed && hasChildren) ? <CustomDropdown {...{ isActiveKey, handleItemClick, closeOpenMenu, disableOptions }} items={item?.children || []} TitleComp={<span className={`dropdown-title`}>
				{t(item.label)}
			</span>}>
				<NavItem {...{ item, isActive: isOpen, isOpen, hasChildren: false, showToolTip: collapsed, onClick: () => handleItemClick(item), disableOptions }} />
			</CustomDropdown> : <>
				<NavItem {...{ item, isActive, isOpen, hasChildren, showToolTip: collapsed, onClick: () => handleItemClick(item), loading, disableOptions }} />
				{hasChildren && (
					<div key={item.children?.length} className={styles.subMenu} style={{ maxHeight: (isOpen && !loading) ? `${item.children!.length * 40}px` : '0px' }}>
						{item.children!.map((child, index) => {
							const childId = child.id || null;
							return <div key={`${child.key}-${index}`} {...(childId ? { id: childId } : {})}
							className={classNames(styles.navItem, { [styles['navItem--active']]: isActiveKey === child.path }, { [styles['navItem--disabled']]: disableOptions && !child.allowClick })}
							onClick={() => handleItemClick(child)}>
							{child.icon && <span className={styles.navItem__icon}>{child.icon}</span>}
							<span className={styles.navItem__label}>{t(child.label)}</span>
						</div>
						})}
					</div>
				)}
			</>}
		</div>
	);
};

export default RenderNavItem;